module.exports = __webpack_public_path__ + "img/niger.b053d8ff.png";